import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Trash = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      viewBox="0 0 14 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={props.className}
    >
      <defs>
        <path
          d="M14,3.99999995 C15.1048565,3.99999995 16,4.89514346 16,5.99999995 L16,5.99999995 L15.9993333,6.66599995 L18,6.66666663 C18.3681899,6.66666663 18.6666667,6.96514347 18.6666667,7.3333333 C18.6666667,7.67522387 18.4093066,7.95700475 18.0777475,7.99551482 L18,7.99999997 L17.9633333,7.99999995 L17.4023069,18.1083134 C17.3455271,19.1303499 16.5296381,19.9381764 15.519992,19.9966135 L15.4026667,20 L8.59733331,20 C7.57361912,20 6.72191774,19.2300267 6.60758158,18.2252657 L6.59769345,18.1083203 L6.03533329,7.99999995 L5.99999996,7.99999997 C5.63181013,7.99999997 5.33333329,7.70152314 5.33333329,7.3333333 C5.33333329,6.99144274 5.59069342,6.70966186 5.92225255,6.67115179 L5.99999996,6.66666663 L7.99933329,6.66599995 L7.99999997,5.99999995 C7.99999997,4.94536421 8.81561627,4.08180992 9.85070197,4.00548399 L9.99999997,3.99999995 Z M16.6283333,7.99999995 L7.37033329,7.99999995 L7.92897354,18.0343534 C7.947279,18.3638516 8.20144632,18.6266335 8.52220662,18.6624927 L8.59733331,18.6666667 L15.4026667,18.6666667 C15.7326705,18.6666667 16.009102,18.4274204 16.0626926,18.1091287 L16.0710268,18.0343465 L16.6283333,7.99999995 Z M14.3566962,11.0905538 C14.5970401,11.3308552 14.6155599,11.7090076 14.4122331,11.9705531 L14.3567795,12.0333628 L12.9423333,13.4469999 L14.3567795,14.8619705 C14.6171061,15.122343 14.6170687,15.544453 14.3566962,15.8047795 C14.1163523,16.0450809 13.7381966,16.0635339 13.4766871,15.8601608 L13.4138872,15.8046962 L11.9993333,14.3899999 L10.5861128,15.8046962 C10.3257863,16.0650687 9.90367634,16.0651061 9.6433038,15.8047795 C9.40295992,15.5644781 9.38444013,15.1863257 9.58776694,14.9247803 L9.64322046,14.8619705 L11.0563333,13.4469999 L9.64322046,12.0333628 C9.38289395,11.7729903 9.38293126,11.3508803 9.6433038,11.0905538 C9.88364769,10.8502524 10.2618034,10.8317995 10.5233129,11.0351725 L10.5861128,11.0906371 L11.9993333,12.5039999 L13.4138872,11.0906371 C13.6742137,10.8302646 14.0963237,10.8302273 14.3566962,11.0905538 Z M14,5.33333329 L9.99999999,5.33333329 C9.63152315,5.33333329 9.33333332,5.63152313 9.33333332,5.99999996 L9.33333332,5.99999996 L9.33333332,6.66666663 L14.6666667,6.66666663 L14.6666667,5.99999996 C14.6666667,5.6578429 14.409554,5.37629045 14.0778005,5.33781437 L14.0778005,5.33781437 L14,5.33333329 Z"
          id="path-1-trash-line"
        ></path>
      </defs>
      <g
        id="icon-24x24px[16x16px]---line&amp;solid"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Atom/icon/basic-UI/trash-cancel/line"
          transform="translate(-5.000000, -4.000000)"
        >
          <mask
            id="mask-2-trash-line"
            fill={props.color || theme.palette.grey600}
          >
            <use xlinkHref="#path-1-trash-line"></use>
          </mask>
          <use
            id="Combined-Shape"
            fill={props.color || theme.palette.grey600}
            fillRule="nonzero"
            xlinkHref="#path-1-trash-line"
          ></use>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      viewBox="0 0 14 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={props.className}
    >
      <defs>
        <path
          d="M18,6.66666663 L16,6.66666663 L16,5.99999995 C16,4.89733329 15.1026667,3.99999995 14,3.99999995 L9.99999999,3.99999995 C8.89733331,3.99999995 7.99999997,4.89733329 7.99999997,5.99999995 L7.99999997,6.66666663 L5.99999996,6.66666663 C5.63199996,6.66666663 5.33333329,6.9653333 5.33333329,7.3333333 C5.33333329,7.70133331 5.63199996,7.99999995 5.99999996,7.99999995 L18,7.99999995 C18.368,7.99999995 18.6666667,7.70133331 18.6666667,7.3333333 C18.6666667,6.9653333 18.368,6.66666663 18,6.66666663 Z M14.6666667,6.66666663 L9.33333332,6.66666663 L9.33333332,5.99999996 C9.33333332,5.63266663 9.63266665,5.33333329 9.99999999,5.33333329 L14,5.33333329 C14.3673333,5.33333329 14.6666667,5.63266663 14.6666667,5.99999996 L14.6666667,6.66666663 Z M6.58866663,18.75 C6.63266663,19.4526667 7.2153333,20 7.91933331,20 L16.0806667,20 C16.7846667,20 17.3673334,19.4526667 17.4113334,18.75 L18,9.33333332 L5.99999996,9.33333332 L6.58866663,18.75 Z M9.64266665,13.2526667 C9.38333332,12.9933333 9.38333332,12.5693333 9.64266665,12.31 C9.90199999,12.0506667 10.326,12.0506667 10.5853333,12.31 L12,13.724 L13.414,12.31 C13.6733333,12.0506667 14.0973333,12.0506667 14.3566667,12.31 C14.616,12.5693333 14.616,12.9933333 14.3566667,13.2526667 L12.9426667,14.6666667 L14.3566667,16.0806667 C14.616,16.34 14.616,16.764 14.3566667,17.0233334 C14.0973333,17.2826667 13.6733333,17.2826667 13.414,17.0233334 L12,15.6093334 L10.586,17.024 C10.3266667,17.2833334 9.90266665,17.2833334 9.64333332,17.024 C9.38399998,16.7646667 9.38399998,16.3406667 9.64333332,16.0813334 L11.0573333,14.6666667 L9.64266665,13.2526667 Z"
          id="path-1-trash-solid"
        ></path>
      </defs>
      <g
        id="icon-24x24px[16x16px]---line&amp;solid"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Atom/icon/basic-UI/trash-cancel/solid"
          transform="translate(-5.000000, -4.000000)"
        >
          <mask
            id="mask-2-trash-solid"
            fill={props.color || theme.palette.grey600}
          >
            <use xlinkHref="#path-1-trash-solid"></use>
          </mask>
          <use
            id="Atom/icon/trash-cancel"
            fill={props.color || theme.palette.grey600}
            fillRule="nonzero"
            xlinkHref="#path-1-trash-solid"
          ></use>
        </g>
      </g>
    </svg>
  );
